/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CouponAssignmentWithPromotion,
  CouponPromotionDetails,
  CouponPromotionDetailsResponseWithAssignmentCounts,
  ErrorResponse,
} from '../models/index';
import {
    CouponAssignmentWithPromotionFromJSON,
    CouponAssignmentWithPromotionToJSON,
    CouponPromotionDetailsFromJSON,
    CouponPromotionDetailsToJSON,
    CouponPromotionDetailsResponseWithAssignmentCountsFromJSON,
    CouponPromotionDetailsResponseWithAssignmentCountsToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface CreateCouponPromotionRequest {
    customerId: string;
    authorization: string;
    promotionName: string;
    promotionDescription: string;
    startDate: string;
    endDate: string;
    expirationDate: string;
    couponFile: Blob;
    templateImageFile: Blob;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetCouponImageRequest {
    promotionId: string;
    couponId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetCouponPromotionRequest {
    promotionId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetCouponPromotionsRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetCouponsForPlayerRequest {
    playerLookupId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class CouponsApi extends runtime.BaseAPI {

    /**
     * Create coupon promotion
     */
    async createCouponPromotionRaw(requestParameters: CreateCouponPromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createCouponPromotion().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling createCouponPromotion().'
            );
        }

        if (requestParameters['promotionName'] == null) {
            throw new runtime.RequiredError(
                'promotionName',
                'Required parameter "promotionName" was null or undefined when calling createCouponPromotion().'
            );
        }

        if (requestParameters['promotionDescription'] == null) {
            throw new runtime.RequiredError(
                'promotionDescription',
                'Required parameter "promotionDescription" was null or undefined when calling createCouponPromotion().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling createCouponPromotion().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling createCouponPromotion().'
            );
        }

        if (requestParameters['expirationDate'] == null) {
            throw new runtime.RequiredError(
                'expirationDate',
                'Required parameter "expirationDate" was null or undefined when calling createCouponPromotion().'
            );
        }

        if (requestParameters['couponFile'] == null) {
            throw new runtime.RequiredError(
                'couponFile',
                'Required parameter "couponFile" was null or undefined when calling createCouponPromotion().'
            );
        }

        if (requestParameters['templateImageFile'] == null) {
            throw new runtime.RequiredError(
                'templateImageFile',
                'Required parameter "templateImageFile" was null or undefined when calling createCouponPromotion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['authorization'] != null) {
            headerParameters['Authorization'] = String(requestParameters['authorization']);
        }

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['promotionName'] != null) {
            formParams.append('promotionName', requestParameters['promotionName'] as any);
        }

        if (requestParameters['promotionDescription'] != null) {
            formParams.append('promotionDescription', requestParameters['promotionDescription'] as any);
        }

        if (requestParameters['startDate'] != null) {
            formParams.append('startDate', requestParameters['startDate'] as any);
        }

        if (requestParameters['endDate'] != null) {
            formParams.append('endDate', requestParameters['endDate'] as any);
        }

        if (requestParameters['expirationDate'] != null) {
            formParams.append('expirationDate', requestParameters['expirationDate'] as any);
        }

        if (requestParameters['couponFile'] != null) {
            formParams.append('couponFile', requestParameters['couponFile'] as any);
        }

        if (requestParameters['templateImageFile'] != null) {
            formParams.append('templateImageFile', requestParameters['templateImageFile'] as any);
        }


        let urlPath = `/v1/{customerId}/coupons/promotions`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create coupon promotion
     */
    async createCouponPromotion(requestParameters: CreateCouponPromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCouponPromotionRaw(requestParameters, initOverrides);
    }

    /**
     * Get coupons barcode image for a particular coupon
     */
    async getCouponImageRaw(requestParameters: GetCouponImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling getCouponImage().'
            );
        }

        if (requestParameters['couponId'] == null) {
            throw new runtime.RequiredError(
                'couponId',
                'Required parameter "couponId" was null or undefined when calling getCouponImage().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCouponImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:barcodes"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/coupons/{promotionId}/barcode-image/{couponId}`;
        urlPath = urlPath.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId'])));
        urlPath = urlPath.replace(`{${"couponId"}}`, encodeURIComponent(String(requestParameters['couponId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get coupons barcode image for a particular coupon
     */
    async getCouponImage(requestParameters: GetCouponImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getCouponImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a coupon promotion
     */
    async getCouponPromotionRaw(requestParameters: GetCouponPromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponPromotionDetails>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling getCouponPromotion().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCouponPromotion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:coupons"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/coupons/promotions/{promotionId}`;
        urlPath = urlPath.replace(`{${"promotionId"}}`, encodeURIComponent(String(requestParameters['promotionId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponPromotionDetailsFromJSON(jsonValue));
    }

    /**
     * Get a coupon promotion
     */
    async getCouponPromotion(requestParameters: GetCouponPromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponPromotionDetails> {
        const response = await this.getCouponPromotionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get coupon promotions
     */
    async getCouponPromotionsRaw(requestParameters: GetCouponPromotionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponPromotionDetailsResponseWithAssignmentCounts>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCouponPromotions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:coupons"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/coupons/promotions`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponPromotionDetailsResponseWithAssignmentCountsFromJSON(jsonValue));
    }

    /**
     * Get coupon promotions
     */
    async getCouponPromotions(requestParameters: GetCouponPromotionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponPromotionDetailsResponseWithAssignmentCounts> {
        const response = await this.getCouponPromotionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get coupons assigned to a player
     */
    async getCouponsForPlayerRaw(requestParameters: GetCouponsForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CouponAssignmentWithPromotion>>> {
        if (requestParameters['playerLookupId'] == null) {
            throw new runtime.RequiredError(
                'playerLookupId',
                'Required parameter "playerLookupId" was null or undefined when calling getCouponsForPlayer().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCouponsForPlayer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:player-coupons"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/coupons/player/{playerLookupId}`;
        urlPath = urlPath.replace(`{${"playerLookupId"}}`, encodeURIComponent(String(requestParameters['playerLookupId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CouponAssignmentWithPromotionFromJSON));
    }

    /**
     * Get coupons assigned to a player
     */
    async getCouponsForPlayer(requestParameters: GetCouponsForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CouponAssignmentWithPromotion>> {
        const response = await this.getCouponsForPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
